export default __webpack_public_path__ + "static/media/Mark-3-Suit-Cycles-00.bb79c592.jpg";